import React, {Component} from 'react';
import _ from 'lodash';

import Api from 'util/Api';

class PatientConsent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            uploading: false
        };

        this.fileInput = React.createRef();

        this.handleFileSelect = this.handleFileSelect.bind(this);
        this.handleRemoveForm = this.handleRemoveForm.bind(this);
    }

    clearPhotoInput() {
        this.setState({
            isPhotoSelected: false,
            photo: {},
        });

        this.props.onChange({
            target: {
                name: 'photo',
                value: null,
            }
        });
        this.props.onChange({
            target: {
                name: 'photoUrl',
                value: null,
            }
        });
    }

    handleFileSelect(event) {
        event.persist();

        const file = this.fileInput.current.files[0];

        if (file && (file.size > 1e7 || !['image/jpeg', 'application/pdf'].includes(file.type))) {
            alert('Please select a .jpg or .pdf file smaller than 10MB.');
            this.clearFileInput();
        } else {
            this.setState({
                uploading: true
            });

            const reader = new FileReader();

            reader.onload = (read) => {
                const fileForSubmit = {
                    mimetype: file.type,
                    filename: file.name,
                    data: read.target.result,
                };

                Api.withAuth(this.props.auth).uploadPatientForm({file: fileForSubmit, patientId: this.props.patient.id})
                    .then((data) => {
                        event.target.value = null;
                        this.setState({
                            uploading: false
                        });

                        this.props.onChange({
                            target: {
                                name: 'forms',
                                value: [
                                    ...this.props.patient.forms,
                                    data
                                ],
                            }
                        });
                    });
            };

            reader.readAsArrayBuffer(file);
        }
    }

    handleRemoveForm(event, form) {
        event.preventDefault();

        if (window.confirm(`The file ${form.originalFilename} will be permanently deleted. Are you sure?`)) {
            Api.withAuth(this.props.auth).deletePatientForm({file: form.filename, patientId: this.props.patient.id})
                .then(() => {
                    this.props.onChange({
                        target: {
                            name: 'forms',
                            value: [
                                ..._.without(this.props.patient.forms, form),
                            ],
                        }
                    });
                });
        }
    }

    render() {
        const demo = this.props.auth.isDemoUser();

        const {patient} = this.props;

        return (
            <div className='consent-forms'>
                <div className='consent-form-selector'>
                    <div className='form-file-input'>
                        <input type='file' id='file' ref={this.fileInput} onChange={this.handleFileSelect} />
                        <label
                            htmlFor='file'
                            className={`btn btn-primary ${(this.state.uploading || demo) ? 'disabled' : ''}`}
                            onClick={(event) => ((this.state.uploading || demo) ? event.preventDefault() : _.noop())}>
                            {this.state.uploading ? 'Uploading...' : `New Form${demo ? ' [DEMO]' : ''}`}
                        </label>
                    </div>
                </div>
                {_.get(patient, 'forms.length', 0) === 0 ? (
                    <div className='empty'>No forms yet</div>
                ) : (
                    <div className='form-list'>
                        <h5>Name</h5>
                        {patient.forms.map((form) => (
                            <div className='form-item' key={form.filename}>
                                <span className='name'>{form.originalFilename}</span>
                                <span className='actions'>
                                    <span className='btn-link' onClick={(event) => { event.preventDefault(); this.props.onViewForm({url: form.signedUrl, filename: form.originalFilename}); }}>View</span>
                                    <span className='separator'>|</span>
                                    <span className='btn-link' onClick={(event) => this.handleRemoveForm(event, form)}>Delete</span>
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        );
    }
}

export default PatientConsent;
